import { Grid } from '@design-systems/canvas-ui'
import './guest.css'
import { BasicPlaceholder } from 'components/placeholder'
import { ErrorAlert } from 'components/error-fallback'
import { useMyTargetPerformanceTeamMetrics } from 'hooks/myTarget-performance/useMyTargetPerformanceTeamMetrics'
import { useMyTargetPerformanceTeamGoals } from 'hooks/myTarget-performance/useMyTargetPerformanceTeamGoals'
import { useMyTargetPerformanceTab } from 'hooks/myTarget-performance/useMyTargetPerformanceTab'
import { PerformanceMetricCards } from './performance-metric-cards'

export const Team = () => {
    const {
        filteredMetrics,
        dataByTimeDimension,
        goalsData,
        isLoading,
        isError,
        error,
        refetch,
    } = useMyTargetPerformanceTab({
        useMetricsHook: useMyTargetPerformanceTeamMetrics,
        useGoalsHook: useMyTargetPerformanceTeamGoals,
    })

    if (isLoading) {
        return (
            <div
                className="placeholder-container hc8-pt-6x"
                data-testid="placeholder"
            >
                <BasicPlaceholder type="table" rows={5} columns={3} />
            </div>
        )
    }

    if (isError) {
        return <ErrorAlert error={error} onRetry={() => refetch()} />
    }

    return (
        <Grid.Container>
            <PerformanceMetricCards
                data={filteredMetrics}
                dataByTimeDimension={dataByTimeDimension}
                goalsData={goalsData}
                tabName="team"
            />
        </Grid.Container>
    )
}
